import timeZoneMap from './timezones.json';

type TimeZoneMapping = Record<string, string>;

const timeZoneData: TimeZoneMapping = timeZoneMap;

export function getMappedTimeZone(key: string): string {
  return timeZoneData[key] || 'America/Los_Angeles';
}
